<template>

  <div class="all">
    <div class="panel-left">
      <div>
        <div style="width: 100%;text-align: center" >
<!--          <b-avatar class="my-avatars" size="6rem" variant="info" :src="profile.avatar"></b-avatar>-->
          <div class="my-name" style="text-align: center">{{ profile.name }}</div>
        </div>
        <ul class="left-list">
          <li v-for="(list, index) in leftList" :key="index" :class="type == index ? 'list-choose' : ''" @click="switchTap(index)">
            <img :src="type == index ? list.chooseIcon : list.icon" alt="" />
            {{ list.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="panel-right">
      <!--个人信息-->
      <user_base  v-if='type == 3' :user_profile="profile"></user_base>
      <!--课程日历-->
      <overview v-if='type == 0' ref='overview'></overview>
      <!--留学申请-->
      <my_studyabroad v-if='type == 1'></my_studyabroad>
      <!--直播课表-->
      <live_list v-if='type == 2' ref='liveList'></live_list>
    </div>
     <!--正在直播的课程-->
      <drag_drop  positionX='1.06' positionY='33.18' ></drag_drop>
  </div>
</template>

<script>

import my_studyabroad from '../mycenter_studyabroad/studyabroad'
import drag_drop from './component/drag_drop.vue'
import live_list from './component/live_list.vue'
import overview from './component/overview.vue'
import user_base from './component/user_base.vue'
import merge from 'webpack-merge'
import { student_profile } from '@/api/login.js'
import { profile_update } from '@/api/mycenter.js'

export default {
  components: {
    live_list,
    my_studyabroad,
    overview,
    drag_drop,
    user_base
  },
  name: 'mycenter',
  data () {
    return {
      profile: {

      },
      input: '',
      text: '', // 驳回内容
      type: 0, // 点击类型
      leftList: [
        {
          name: '课程日历',
          icon: require('../../images/live-b.png'),
          chooseIcon: require('../../images/live-y.png')
        },
        {
          name: '留学申请',
          icon: require('../../images/live-b.png'),
          chooseIcon: require('../../images/personal-y.png')
        },
        {
          name: '直播课表',
          icon: require('../../images/live-b.png'),
          chooseIcon: require('../../images/live-y.png')
        }
      ]
     }
  },
  watch: {
    $route: function (to, from) {
      this.type = to.query.type
    },
    immediate: true,
    deep: true
  },
  created () {

    this.switchTap(this.$route.query.type)
    this.studentProfile()
  },
  methods: {
    studentProfile () {
      // 获取个人资料
      student_profile()
        .then(response => {
          this.profile = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    switchTap (_num) {
      // 切换左边栏按钮
      this.type = _num
      this.$router.push({
        query: merge(this.$route.query, {'type': _num})
      })
    }
  }
}
</script>

<style>

.third-title{
  text-align: left;font-weight: 600;margin-top: 10px
}
.third-title-p{
  text-align: left;font-weight: 600;margin:25px 0 10px 0
}
.brief_introduction{
  padding: 5px  15px;
}
.no-list{
  width: 260px;
  height: 200px;
  margin:50px  auto 0 auto;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.no-list img{
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
}
.file-botton{
  display: flex;
  justify-content: flex-end;
}
.file-bottons{
  color: #FFFFFF;
  background: #FD9800;
  width: 5.2375rem;
  height: 1.9375rem;
  line-height: 1rem;
  margin-top: 0.625rem;
}
.file-submit{
  display: flex;
  justify-content: space-between;

}
.file-submit div{
  text-align: left;
  font-size: 0.875rem;
  cursor: pointer;
}
.file-submit:hover span, .file-submit:hover div{
  color: red;
}
.file-submit-list span{
  margin-right: 1.25rem;
  color: #999999;
}
.collapsed:focus {
  outline: none!important;
}
.not-collapsed:focus {
  outline: none!important;
}
.waiting-for{
  outline: none!important;
}
.choose-file{
  width: 100%;
  height: 4.25rem;
  position: relative;
  margin-top: 1.25rem;
}
.choose-file-text{
  color: #FF0000;
  font-size: 0.625rem;
  text-align: left;
  margin-top: 0.625rem;
}
.choose-file>.custom-file-input{
  width: 100%;
  height: 4.25rem!important;
  border: none;
  position: relative;
  border: 1px solid red;
  z-index: 99!important;
}
.choose-file .custom-file-label::before {
  position: absolute;
  top: 25px;
  right: 2rem;
  bottom: 0;
  /*left: 0;*/
  text-align: left;
  padding-left: 227px;
  content: '拖动文件到此区域或者点击上传文件'!important;
  z-index: 2;
  font-size: 0.75rem;
}
.choose-file .custom-file-label{
  height: 4.25rem!important;
  border: 1px dashed #AAAAAA!important;
  border: none;
}
.choose-file .custom-file-label::after {
  margin: auto 15px;
  left: 0;
  content: '上传文件'!important;
  width: 85px;
  height: 25px;
  background: none!important;
  line-height: 15px;
  color: #FD9800;
  font-size:0.875rem ;
  border: 1px solid #FD9800;
  border-radius: 3px;
  z-index: 9999;
}
.choose-file .d-block{
  display: none!important;
}
.input-model {
  width: 18.75rem;
  border-bottom: 1px solid #aaaaaa;
  border-radius: 0;
}
.waiting-for {
  color: #fd9801 !important;
}
.failed {
  color: #fd0000 !important;
}
.pass {
  color: #45f111 !important;
}
.submit-file {
  width: 8.375rem;
  height: 2.6875rem;
  background: linear-gradient(89deg, #fdcf00 0%, #fdb100 100%);
  opacity: 1;
  border-radius: 1.3125rem;
  margin-bottom: 2.6875rem;
}
.information-input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 0.9rem;
  color: #999999;
}
.information-input::-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 0.9rem;
  color: #999999;
}
.information-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 0.9rem;
  color: #999999;
}
.information-input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 0.9rem;
  color: #999999;
}

.right-list li label span {
  width: 2.125rem;
}

.form-group {
  margin-bottom: 0;
}
.information-select {
  outline: none;
  border: none;
  background: transparent;
}
.information-select:focus,
.information-select:active {
  border-bottom: 1px solid #aaaaaa;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0);
}

.ant-select-selection:hover {
  border-color: #cccccc;
}
.file-updete {
  margin: 0;
  padding: 0;
  width: 0;
}
.file-updete label {
  width: 72px;
  margin: 0;
  padding: 0;
}
.file-updete input {
  display: none;
  border: none;
}
.status-write {
  color: #ffffff !important;
}
.status-back {
  color: #000000 !important;
}
.examine-content {
  display: flex;
  align-items: center;
  font-size: 0.9375rem;
  color: #fd0000 !important;
}
.list-unstyled {
  margin: 0.5rem auto 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.file-lsit .down-file {
  color: #fd9800;
}
.file-lsit p {
  font-size: 0.875rem;
  /*margin: 0.625rem 0 0 0 !important;*/
  color: #363636;
  /*overflow: hidden;*/
  /*text-overflow:ellipsis;*/
  /*white-space: nowrap;*/
  /*margin-left: 30rem;*/
  margin: 0 auto;
  padding-right: 1rem;
  /*float: left;*/
}
.file-lsit img {
  /*width: 2.625rem;*/
  /*height: 3.6875rem;*/
  object-fit: cover;
  /*margin-top: 1.25rem;*/
}
.file-lsit {
  /*width: 7.5rem;*/
  /*height: 8.25rem;*/
  margin: 0 auto;
  text-align: left;
  width: 100%;
}
.content-time {
  text-align: left;
  font-size: 1rem;
  color: #aaaaaa;
  /*margin-top: 0.9375rem;*/
}
.content-list {
  border-bottom: 2px solid #aaaaaa;
  padding-bottom: 0.25rem;
}
.audit-content span {
  font-size: 0.85rem;
  font-weight: 400;
  color: #aaaaaa;
}
.audit-content {
  text-align: left;
  /*margin-top: 1.25rem;*/
  margin-bottom: 1.25rem;
}
.audit-content p {
  font-size: 0.85rem;
  line-height: 1.0625rem;
  color: #1a1a1a;
  text-align: left;
  margin: 0.3125rem 0;
}
.submit-questionnaire:active,
.submit-questionnaire:focus {
  color: #ffffff;
  background-color: #fd9800;
}
.submit-questionnaire {
  color: #ffffff;
  background-color: #fd9800;
  padding: 0.425rem 2.5rem;
}
.content-top span:nth-child(1) {
  color: #fd9800;
  font-weight: bold;
}
.content-top span:nth-child(2) {
  color: #fd9800;
}
.content-top > .failed {
  color: #fd0000 !important;
}
.content-top {
  display: flex;
  justify-content: space-between;
  margin-top: 0.625rem;
  font-size: 0.875rem;
}
.wait-heng {
  width: 100%;
  border-bottom: 2px solid #fd9800;
  height: 14px;
}
.wait-heng .caret-up-fill {
  width: 2.7rem;
  margin-right: 1.875rem;
}
.wait-status {
  width: 100%;
  text-align: left;
  margin-top: 1.45rem;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.1875rem;
  color: #fd9800;
}
.rocket {
  width: 27px;
  height: 25px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 99;
}
.wait-status span {
  margin-right: 1.875rem;
  cursor: pointer;
}
.speeding li:nth-child(1) .speeding-status .speeding-left {
  background-color: #ffffff !important;
}
.speeding li:last-child .speeding-status .speeding-right {
  background-color: #ffffff !important;
}
.speeding-gray {
  background-color: #e7e7e7 !important;
}
.speeding-name {
  font-size: 0.625rem;
  font-weight: 400;
  line-height: 0.8125rem;
  color: #1a1a1a;
}
.speeding-left {
  display: block;
  width: 50%;
  height: 100%;
  background-color: #e7e7e7;
  float: left;
}
.speeding-right {
  display: block;
  width: 50%;
  height: 100%;
  background-color: #e7e7e7;
  float: left;
}
.speeding-center-complete {
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  border: 2px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99;
  background-color: #e7e7e7;
}
.speeding-status {
  width: 100%;
  height: 0.625rem;
  position: relative;
  margin: 0.325rem 0;
}
.speeding-time {
  font-size: 0.775rem;
  font-weight: 400;
  line-height: 0.8125rem;
  color: #1a1a1a;
  display: block;
  width: 5.5rem;
  line-height: 1.25rem;
  margin: 0 auto;
  padding:0.9375rem 1rem 0 1rem ;
}
.speeding li {
  width: 10%;
  list-style: none;
  padding-top: 0.9375rem;
}
.speeding {
  width: 100%;
  padding-left: 0px;
  overflow-x: scroll;
  display: flex;
}
.speeding::-webkit-scrollbar {
//  display:none
}
.wait-name {
  font-size: 1.0625rem;
  font-weight: bold;
  line-height: 1.3125rem;
  color: #1a1a1a;
  text-align: left;
  margin-top: 2.1875rem;
}
.order-none img {
  width: 6.5rem;
  height: 6.5rem;
  margin-top: 12.5rem;
}
.order-box {
  display: flex;
  width: 100% !important;
  align-items: center;
}
.order-box .order-price {
  border-left: 0.0625rem solid #e6e6e8;
  height: 4rem;
  line-height: 4rem;
  font-size: 0.8125rem;
}
.order-price1 {
  color: #aaaaaa;
}
.order-price2 {
  color: #ff0404;
}
.order-price3 {
  color: #1a1a1a;
}
.order-img {
  width: 100% !important;
  margin-top: 0.9375rem;
  display: flex;
  justify-content: space-between;
}
.order-img div {
  width: calc(100% - 100px) !important;
  display: flex;
  justify-content: space-between;
  align-content: left;
  flex-flow: column;
  text-align: left;
  padding: 0.3125rem 0;
}
.order-img img {
  width: 90px;
  height: 90px;
  object-fit: cover;
}
.order-time {
  font-size: 0.625rem;
  color: #aaaaaa;
  width: 100% !important;
  display: flex;
  height: 1.875rem;
  background: #f6f6f6;
  align-items: center;
  padding-left: 0.625rem;
}
.order-time span span {
  color: #1a1a1a;
}
.order-time span:nth-child(1) {
  margin-right: 1.5625rem;
}
.order-product {
  padding: 0.4375rem 0.625rem;
}
.order-content {
  list-style: none;
  background: #ffffff;
  border: 1px solid #e6e6e8;
  border-radius: 0.4375rem;
  margin-bottom: 0.9375rem;
}
.order-list {
  margin: 0;
  padding: 0;
}
.order-top {
  height: 1.875rem;
  background: #f6f6f6;
  display: flex;
  align-items: center;
}
.order-title {
  display: flex;
  width: 100%;
  margin: 2.3125rem 0 0.9375rem 0;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 0.9375rem;
  color: #1a1a1a;
  border: 1px solid #e6e6e8;
}
.order-title div:nth-child(1),
.order-box div:nth-child(1) {
  width: 50%;
}
.order-title div:nth-child(2),
.order-box div:nth-child(2) {
  width: 16%;
}
.order-title div:nth-child(3),
.order-box div:nth-child(3) {
  width: 16%;
}
.order-title div:nth-child(4),
.order-box div:nth-child(4) {
  width: 16%;
}
.choose-gender {
  margin-right: 2.5rem;
}
.information-input:active,
.information-input:focus {
  width: 18.75rem;
  border-bottom: 1px solid #aaaaaa;
  border-radius: 0;
}
.information-input {
  width: 18.75rem;
  border-bottom: 1px solid #aaaaaa;
  border-radius: 0;
}
.right-list {
  margin: 0;
  padding: 0.125rem 0 3.125rem 0rem;
}
.content-questionnaire {
  padding: 1.25rem !important;
}
.content-questionnaire li {
  margin-top: 1rem !important;
}
.content-questionnaire li span {
  font-size: 0.9rem !important;
}
.right-list li {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  margin-top: 2.5rem;
  align-items: center;
  font-size: 0.75rem !important;
}
.right-list li span {
  display: block;
  width: 120px;
  text-align: right;
  font-size: 1rem;
  color: #1a1a1a;
  margin-right: 3.75rem;
}
.my-information {
  width: 100%;
}
.my-information::-webkit-scrollbar {
  width: 0 !important;
}
.my-information {
  -ms-overflow-style: none;
}
.my-information {
  overflow: -moz-scrollbars-none;
}
.left-list {
  margin: 5.625rem 0 0 0;
  padding: 0;
}
.left-list li {
  list-style: none;
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #1a1a1a;
  border-left: 0.22rem solid #f2f2f2;
  cursor: pointer;
}

.list-choose {
  border-left: 0.22rem solid #fd9800 !important;
  color: #fd9800 !important;
  font-weight: bold;
  background-color: #ffffff;
}
.left-list li img {
  width: 0.8625rem;
  height: 1rem;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: -0.2rem;
  margin-right: 0.825rem;
}

.my-name {
  font-size: 0.9375rem;
  font-weight: bold;
  line-height: 1.3125rem;
  color: #1a1a1a;
}
.my-avatars {
  margin: 2.5rem auto 0.9375rem auto;
}
.all {
  min-height: 45.6875rem;
  background: #ffffff;
  /* box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.16); */
  /* opacity: 1; */
  /* border-radius: 0.9375rem; */
  /* margin: 1.5rem auto; */
  display: flex;
  justify-content: space-between;
  padding: 0;
  position: relative;
}
.panel-left {
  width: 15%;
  background: #f2f2f2;
  /* border-top-left-radius: 0.9375rem; */
  /* border-bottom-left-radius: 0.9375rem; */

}
.panel-right {
  /* width: 90%; */
  flex: 1;
  background: #ffffff;
  border-top-right-radius: 0.9375rem;
  border-bottom-right-radius: 0.9375rem;
  padding: 0 1.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter/mycenter.vue